import React from 'react'
import IcomoonReact from 'icomoon-react'
import classNames from 'classnames'
import iconSet from 'src/assets/icons/iconList.json'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import preloginStyles from './navigation.module.scss'

const PreloginNavigationHeader = ({ back, close, onClick }) => (
  <div className={preloginStyles.navContainer}>
    {back && (
      <button
        className={classNames(
          preloginStyles.buttonContainer,
          preloginStyles.back
        )}
        onClick={onClick}
      >
        <IcomoonReact
          iconSet={rebrandIconSet}
          className={preloginStyles.navBtn}
          icon="Controls-Back"
        />
      </button>
    )}
    {close && (
      <button
        className={classNames(
          preloginStyles.buttonContainer,
          preloginStyles.right,
          preloginStyles.close
        )}
        onClick={onClick}
      >
        <IcomoonReact
          iconSet={iconSet}
          className={preloginStyles.navBtn}
          size={12}
          icon="Control-CrossIcon-Large-GreyOutlineBold"
        />
      </button>
    )}
  </div>
)

export default PreloginNavigationHeader
